import { getInquiryCategoryList, postInquiry } from '@/apis/inquiry';
import { INQUIRY } from '../mutation-types';

export const state = {
  inquiryData: {
    inquiry_category_id: null,
    email: '',
    name: '',
    business_name_or_name: '',
    department_name: '',
    phone_number: '',
    content: '',
  },
  inquiryCategories: [],
};
export const getters = {
  inquiryData: state => state.inquiryData,
  inquiryCategories: state => state.inquiryCategories,
};
export const mutations = {
  setInquiryData(state, data) {
    state.inquiryData = data;
  },
  setInquiryDefaultData(state) {
    const defaultData = {
      inquiry_category_id: null,
      email: '',
      name: '',
      content: '',
      business_name_or_name: '',
      department_name: '',
      phone_number: '',
    };
    state.inquiryData = defaultData;
  },
  [INQUIRY.SET_INQUIRY_CATEGORIES](state, data) {
    if (!data.error) {
      state.inquiryCategories = data;
    }
  },
};

export const actions = {
  async getInquiryCategoryList({ commit }) {
    const res = await getInquiryCategoryList();
    commit(INQUIRY.SET_INQUIRY_CATEGORIES, res);
    if (res.error) {
      return {
        error: true,
        messages: res?.error?.response?.data?.errors
      };
    }

    return { error: false };
  },
  async postInquiry({ commit }, params) {
    const res = await postInquiry(params);
    if (res.error) {
      return {
        error: true,
        messages: res?.error?.response?.data?.errors
      };
    }

    return false;
  },
};
